import { useState, useEffect, useCallback } from 'react';
import { message } from 'antd';
import { useStateContext } from '../../../../../contexts/ContextProvider';

export const useAdaugaProduse = () => {
  const { token } = useStateContext();
  const [newProducts, setNewProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0
  });

  const [filters, setFilters] = useState({
    search: '',
    product_id: null,
    manager_id: null,
    client_name: '',
    product_status: null
  });

  const handleSearch = useCallback((value) => {
    setFilters(prev => ({ ...prev, search: value }));
  }, []);

  const handleConfirmProduct = useCallback((product) => {
    // Aici va trebui implementată logica de confirmare a produsului
    message.success(`Produsul ${product.product_name} a fost confirmat`);
  }, []);

  const handleShowDetails = useCallback((product) => {
    // Aici va trebui implementată logica pentru afișarea detaliilor
    console.log('Detalii produs:', product);
  }, []);
  
  const fetchNewProducts = useCallback(async () => {
    if (!token) return;

    setLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/logistica/get_logistic_new_products?token=${token}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setNewProducts(data.items || []);
      } else {
        message.error('Eroare la încărcarea produselor noi');
      }
    } catch (error) {
      console.error('Eroare la fetch produse noi:', error);
      message.error('Eroare de conexiune');
    } finally {
      setLoading(false);    
    }
  }, [token]);

  const deleteProdusRequest = useCallback(async (product_request) => {
    // EL AICI VA FACE UPDATE LA OFERTA SI VA SCOATE DIN INFO REQUESTUL DE PRODUS
    const ofert_id = product_request.oferta_id;
    const product_request_id = product_request.id;

    try {
      const oferta = await fetch(`${process.env.REACT_APP_API_URL}/oferte/${ofert_id}?token=${token}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      const oferta_data = await oferta.json();

      let oferta_new_data = oferta_data.info.new_products.filter(item => item.id !== product_request_id);

      const oferta_update = await fetch(`${process.env.REACT_APP_API_URL}/oferte/${ofert_id}?token=${token}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          info: {
            ...oferta_data.info,
            new_products: oferta_new_data
          }
        })
      });

      if (oferta_update.ok) {
        message.success('Produsul a fost șters din ofertă');
        fetchNewProducts(); // Reîncarcă lista de produse
      } else {
        message.error('Eroare la ștergerea produsului din ofertă');
      }

      const oferta_update_data = await oferta_update.json();
      console.log(oferta_update_data);

    } catch (error) {
      console.error('Eroare la ștergerea produsului:', error);
      message.error('Eroare de conexiune');
    }
  }, [token, fetchNewProducts]);


  const addProductToOferta = useCallback(async (product, oferta_id, product_request) => {
    // Aici va trebui implementată logica de adăugare a produsului la ofertă
    const produsToOferta = await fetch(`${process.env.REACT_APP_API_URL}/oferte/${oferta_id}/produse?token=${token}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        id_produs: product.id,
        bought_price: product?.furnizor?.pret || 0,
        sale_price: product.pret_vanzare || 0,
        product_qt: product_request.quantity || 0,
        product_status: 1
      })
    });

    const produsToOferta_data = await produsToOferta.json();

    if (produsToOferta_data.success) {
      message.success('Produsul a fost adăugat la ofertă');
      fetchNewProducts();
    } else {
      message.error('Eroare la adăugarea produsului la ofertă');
    }


    }, []);

  // Funcție pentru aplicarea filtrelor
  const applyFilters = useCallback((newFilters) => {
    setFilters(newFilters);
    setPagination(prev => ({ ...prev, current: 1 })); // Resetăm la prima pagină
  }, []);

  // Funcție pentru resetarea filtrelor
  const clearFilters = useCallback(() => {
    setFilters({
      search: '',
      product_id: null,
      manager_id: null,
      client_name: '',
      product_status: null
    });
    setPagination(prev => ({ ...prev, current: 1 }));
  }, []);

  // Funcție pentru schimbarea paginii
  const handleTableChange = useCallback((pagination) => {
    setPagination(pagination);
  }, []);

  useEffect(() => {
    fetchNewProducts();
  }, [fetchNewProducts]);

  useEffect(() => {
    console.log(newProducts);
  }, [newProducts]);

  return {
    loading,
    pagination,
    newProducts,
    setNewProducts,
    filters,
    isFilterModalVisible,
    setIsFilterModalVisible,
    handleSearch,
    handleConfirmProduct,
    handleShowDetails,
    applyFilters,
    clearFilters,
    handleTableChange,
    deleteProdusRequest,
    addProductToOferta,
    fetchNewProducts
  };
}; 